document.addEventListener('DOMContentLoaded', () => {
  const paragraphs = $(
    '.wp-block-cover.landing-page-header .wp-block-cover__inner-container > p'
  );
  $($(paragraphs).get().reverse()).each(function () {
    $(this)
      .clone()
      .addClass('landing-page-header-mobile-text')
      .insertAfter('.wp-block-cover.landing-page-header');
  });
});
